// extracted by mini-css-extract-plugin
module.exports = {"social":"_1GkEDUY49B0Xv0N7kAGgKZ","header":"_2t9s57pg8XnQ8qLbaBgAvC","socialItem":"_3AKH6yyQuPT145AdhHtWxm"};